import {
  CheckCircleIcon,
  EyeIcon,
  EyeSlashIcon,
  ShieldCheckIcon,
  ArrowTopRightOnSquareIcon,
} from '@heroicons/react/24/solid';
import { useLocation } from 'react-router-dom';

const Comment = ({
  status,
  username,
  comment,
  index,
  clickEvent,
  selectedComment,
  setSelectedComment,
  timestamp,
  post,
  attachment,
  autoFlagged,
  isHidden,
  manuallyFlagged,
  platformFlagged,
  replyCount,
  platformCommentId,
  onOpenThread,
}: {
  status: any;
  username: string;
  comment: string;
  index: number;
  clickEvent: any;
  selectedComment: number;
  setSelectedComment: any;
  timestamp: any;
  post: any;
  attachment: string;
  autoFlagged: any;
  isHidden?: boolean;
  manuallyFlagged?: boolean;
  platformFlagged?: boolean;
  replyCount: number;
  platformCommentId: string;
  onOpenThread?: (platformCommentId: string) => void;
}) => {
  const location = useLocation();
  const isAutoMod = location.pathname.toLocaleLowerCase() === '/automod';

  // Fixed: More robust check for autoFlagged status
  const isAutoFlagged =
    autoFlagged === 'autoFlagged' || autoFlagged === true || autoFlagged === 1;
  const isHiddenOrFlagged = isHidden || manuallyFlagged || platformFlagged;

  // Determine text color - prioritize autoFlagged
  let textColorClass = '';
  if (isAutoFlagged || (isAutoMod && (status === 0 || status === 1))) {
    textColorClass = 'text-orange';
  } else if (isHiddenOrFlagged) {
    textColorClass = 'text-red-500';
  } else if (status === 0) {
    textColorClass = 'text-white';
  } else if (status === 2) {
    textColorClass = 'text-green-400';
  }

  const handleThreadClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent row selection
    if (onOpenThread) {
      onOpenThread(platformCommentId);
    }
  };

  return (
    <tr
      className={`p-2 border-t border-white border-opacity-20 py-2 cursor-pointer hover:brightness-90 
        ${selectedComment !== index && 'hover:bg-white hover:bg-opacity-10'}
        ${selectedComment === index && `bg-violet`}
        ${textColorClass}
        ${status == 1 && 'opacity-50'}
        ${status === 2 && 'opacity-50'}
        `}
      onClick={() => {
        clickEvent(index);
      }}
    >
      <td className="overflow-hidden">
        {isAutoFlagged || (isAutoMod && (status === 0 || status === 1)) ? (
          <ShieldCheckIcon className="w-6 h-6 mx-auto text-orange" />
        ) : isHiddenOrFlagged ? (
          <EyeSlashIcon className="w-6 h-6 mx-auto text-red-500" />
        ) : status == 2 ? (
          <CheckCircleIcon className="w-6 h-6 mx-auto" />
        ) : null}
      </td>
      <td className="overflow-hidden">
        <img
          src={
            post.mediaUrl ||
            'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg'
          }
          alt="Post"
          className="w-6 w-6 object-cover rounded"
        />
      </td>
      <td className="pl-4 py-2 w-40 truncate" title={username}>
        {' '}
        {/* Added w-40 to match th and truncate */}
        {username}
      </td>
      <td className="py-2 whitespace-nowrap overflow-hidden overflow-ellipsis">
        <div className="truncate">
          {comment || <p className="text-slate-400">Sent an image</p>}
        </div>
      </td>
      <td>
        <button
          onClick={handleThreadClick}
          className="flex items-center space-x-1 px-2 py-1 bg-greythree hover:bg-lightgrey rounded text-xs text-gray-300 hover:text-white transition-colors ml-2 flex-shrink-0"
          title={`View ${replyCount} ${replyCount === 1 ? 'reply' : 'replies'}`}
        >
          {/* Popup/Thread Icon */}
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            />
          </svg>
          <span>{replyCount}</span>
        </button>
      </td>
      <td>
        <span className="text-xs text-white">{timestamp}</span>{' '}
        {/* Apply smaller font size */}
      </td>
    </tr>
  );
};

export default Comment;
